import { Attr, BelongsTo, HasMany, Model } from "spraypaint";
import Application from "./Application";
import ApplicationRecord from "./ApplicationRecord";
import Job from "./Job";
import Recruiter from "./Recruiter";

@Model()
class Engagement extends ApplicationRecord {
  static jsonapiType = "engagements";

  @Attr() applicationsCount: number;

  @Attr() userApplicationCountRead: number;

  @Attr() userApplicationCountUnread: number;

  @Attr() displayState: string;

  @Attr() handlingFee: number;

  @Attr() employerId: number;

  @Attr() jobId: number;

  @Attr() status: EngagementStatus;

  @Attr() respondedAt: string;

  @Attr() recruiterId: number;

  @Attr() recruiterUserId: number;

  @Attr() employerUserId: number;

  @Attr() candidatesLink: string;

  @Attr() employerProfileLink: string;

  @Attr() jobProfileLink: string;

  @Attr() engagementRespondedTo: boolean;

  @Attr() hasConfirmedCustomTerms: boolean;

  @Attr() message: string;

  @Attr() rejectedMessage: string;

  @Attr() disengagedAt: string;

  @Attr() deletedAt: string;

  @BelongsTo(Job) job: Job;

  @BelongsTo(Recruiter) recruiter: Recruiter;

  @HasMany(Application) applications: Application[];
}

export enum EngagementStatus {
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  DISENGAGED = "disengaged",
  PENDING = "pending",
}

export default Engagement;
